import { SENTIMENT } from "@/constants";
import { hashString } from "@/lib/hash";
import newTheme from "@/new_theme";

const DARK_CHART_COLORS = [
  newTheme["primary-700"],
  newTheme["blue-400"],
  newTheme["pink-300"],
  newTheme["blue-700"],
  newTheme["pink-400"],
  newTheme["primary-300"],
  newTheme["pink-700"],
  newTheme["primary-400"],
  newTheme["blue-300"],
];

export const CHART_COLORS = [
  newTheme["blue-600"],
  newTheme["primary-800"],
  newTheme["pink-300"],
  newTheme["primary-100"],
  newTheme["blue-500"],
  newTheme["pink-500"],
  newTheme["primary-300"],
  newTheme["blue-100"],
  newTheme["pink-700"],
  newTheme["primary-400"],
  newTheme["blue-300"],
  newTheme["pink-200"],
];

export const CHART_COLORS_NEW = [
  "var(--chart-1)",
  "var(--chart-2)",
  "var(--chart-3)",
  "var(--chart-4)",
  "var(--chart-5)",
  "var(--chart-6)",
  "var(--chart-7)",
  "var(--chart-8)",
  "var(--chart-9)",
  "var(--chart-10)",
  "var(--chart-11)",
  "var(--chart-12)",
  "var(--chart-13)",
  "var(--chart-14)",
  "var(--chart-15)",
  "var(--chart-16)",
  "var(--chart-17)",
  "var(--chart-18)",
  "var(--chart-19)",
  "var(--chart-20)",
  "var(--chart-21)",
  "var(--chart-22)",
  "var(--chart-23)",
  "var(--chart-24)",
  "var(--chart-25)",
];

export const CHART_COLORS_LIGHTER = {
  [newTheme["blue-600"]]: "#73A3D9",
  [newTheme["blue-500"]]: "#8FBBED",
  [newTheme["blue-300"]]: "#D0EBFF",
  [newTheme["blue-100"]]: "#F1F9FF",
  [newTheme["primary-800"]]: "#8756B7",
  [newTheme["primary-400"]]: "#D0B7F8",
  [newTheme["primary-300"]]: "#DAC5FB",
  [newTheme["primary-100"]]: "#F2EAFF",
  [newTheme["pink-700"]]: "#BE60A3",
  [newTheme["pink-500"]]: "#DBA3CB",
  [newTheme["pink-300"]]: "#F3DCED",
  [newTheme["pink-200"]]: "#FAEBF6",
};

export const CHART_SENTIMENT_COLORS = {
  [SENTIMENT.VERY_POSITIVE]: newTheme["sentiment-very-positive"],
  [SENTIMENT.POSITIVE]: newTheme["sentiment-positive"],
  [SENTIMENT.NEGATIVE]: newTheme["sentiment-negative"],
  [SENTIMENT.VERY_NEGATIVE]: newTheme["sentiment-very-negative"],
  [SENTIMENT.NEUTRAL]: newTheme["gray-500"],
};

const assignedColors: Record<string, Record<string, string>> = {};

interface GetColorOptions {
  title?: string | null;
  dark?: boolean;
  scope?: string | null;
  transparent?: boolean;
}

export const getColor = (
  idx = 0,
  {
    title = null,
    dark = false,
    scope = null,
    transparent = false,
  }: GetColorOptions = {}
): string => {
  const set = dark ? DARK_CHART_COLORS : CHART_COLORS;
  let color = set[idx % set.length];

  if (title) {
    const key = scope ?? "default";

    // create scope unless it exists
    if (!assignedColors[key]) {
      assignedColors[key] = {};
    }

    // get color if already set once
    if (assignedColors[key][title]) {
      color = assignedColors[key][title];
    }
    // find and store color for scope and title
    else {
      const index = Object.keys(assignedColors[key]).length;
      color = set[index % set.length];
      assignedColors[key][title] = color;
    }
  }

  if (transparent) {
    color = `${color}aa`;
  }

  return color;
};

export const getColorBySearchId = (
  searchId: string,
  allSearchIds: string[]
) => {
  const sortedIds = [...allSearchIds].sort();
  const index = sortedIds.indexOf(searchId);

  if (index === -1) {
    const hash = hashString(searchId);
    return CHART_COLORS_NEW[hash % CHART_COLORS_NEW.length];
  }

  return CHART_COLORS_NEW[index % CHART_COLORS_NEW.length];
};
